"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.faChartColumn = void 0;
var faChartColumn = {
  prefix: 'far',
  iconName: 'faChartColumn',
  icon: [512, 512, [], '', 'M488 432H48V56C48 42.74 37.25 32 24 32S0 42.74 0 56V448c0 17.6 14.4 32 32 32h456c13.25 0 24-10.75 24-24C512 442.7 501.3 432 488 432zM168 352C181.3 352 192 341.3 192 328v-48C192 266.8 181.3 256 168 256S144 266.8 144 280v48C144 341.3 154.8 352 168 352zM264 352c13.25 0 24-10.75 24-24v-176C288 138.8 277.3 128 264 128S240 138.8 240 152v176C240 341.3 250.8 352 264 352zM360 352c13.25 0 24-10.75 24-24v-112C384 202.8 373.3 192 360 192S336 202.8 336 216v112C336 341.3 346.8 352 360 352zM456 352c13.25 0 24-10.75 24-24v-208C480 106.8 469.3 96 456 96S432 106.8 432 120v208C432 341.3 442.8 352 456 352z']
};
exports.faChartColumn = faChartColumn;